<template>
  <v-container class="loan-work-queue" grid-list-xl fluid ref="UI" :loanPhase="assist.dataType.LoanPhaseEnum.PAYMENT_PROCESSING.value" :queueType="assist.dataType.QueueTypeEnum.SpecialQueue.value">
   <div class="queue-header-btn">
<!--      <v-btn class="topLeft" text small @click="dialogEventHandler(assist.dataType.DialogActionEnum.DISPLAY)">Date Range-->
<!--        <v-icon right>date_range</v-icon>-->
<!--      </v-btn>-->
      <span :style="languageselected.textStyle">Language:</span>
      <div v-if="languageselected.show">
        <v-select :style="languageselected.style" v-model="selectedLanguage" :items="languages.map(lang => lang.text)"
          class="language-dropdown" single-line @change="filterChange"></v-select>
      </div>
      <div v-else>
        <span :style="languageText.style">{{ selectedLanguage }}</span>
      </div>
   </div>

<!--    <v-dialog max-width="800px" v-model="layoutData.dialog.display" persistent>-->
<!--      <arb-date-range-card-->
<!--        v-if="layoutData.dialog.display"-->
<!--        v-model="layoutData.dialog.data"-->
<!--        :eventHandler="dialogEventHandler"-->
<!--        @showDateRange="showDateRange"-->
<!--      ></arb-date-range-card>-->
<!--    </v-dialog>-->
    <div v-if="flag" class="queue-tab" id="eleItems">
      <template>
        <v-card class="queue-tab-card">
          <v-tabs
            v-model="tab"
            dark
            background-color="#fff"
            show-arrows
            icons-and-text
            grow
            class="loan-queue-tabs"
          >
            <v-tabs-slider :color="sliderColor"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in dataWorkQueue"
              :key="index"
              style="color:#bbb; background: #fff"
              active-class="choose"
              @click="clickItem(index)"
            >
              <div>[{{tab.count}}]</div>
              <div>{{ tab.title }}</div>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="(tab, index) in dataWorkQueue"
              :key="index"
            >
              <v-progress-linear
                v-if="tab.isLoading"
                :color="tab.color[0]"
                indeterminate
                rounded
              ></v-progress-linear>
              <v-card flat>
                <div class="queue-content">
                  <div class="scroll" @scroll="scrollEvent" @mouseover="mouseOver($event)" @mouseleave="mouseLeave($event)">
                    <waterfall :col="cloNumbers" :data="assist.tool.isEmpty(tab.items) ? [] : tab.items">
                      <template v-for="(item, index) in tab.items">
                        <arb-application-queue-item
                          :key="index"
                          :itemData="item"
                          :loanPhase="assist.dataType.LoanPhaseEnum.PAYMENT_PROCESSING.value"
                          :layoutSetting="layoutData.setting.item"
                          :color="tab.color[0]"
                          :secondColor="tab.color[1]"
                          class="item-card"
                          :queueCode="tab.code"
                          :privileges="authorization.privileges"
                          :roleList="roleList"
                        ></arb-application-queue-item>
                      </template>
                    </waterfall>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </div>
  </v-container>
</template>

<script>
import { Tool, DataType } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { PPS_QUEUE_LAYOUT_SETTING } from '@/setting/layout/post-origination/queue'
import { ComplaintApi } from '@/api/lms/complaint'

const $tool = new Tool()
export default {
  props: {
    loanPhase: {
      type: Number
    },
    queueType: {
      type: Number
    },
    isOverflowQueue: {
      type: Boolean,
      require: false,
      default: false
    },
    headers: {
      type: Array,
      default: () => LIST_TABLE_HEADER.WORK_QUEUE_TABLE_HEADERS
    }
  },
  data () {
    return {
      assist: {
        tool: $tool,
        dataType: DataType
      },
      account: {},
      layoutData: {
        setting: {
          workQueue: null,
          item: PPS_QUEUE_LAYOUT_SETTING.ITEM
        }
      },
      filter: {},
      selectedLanguage: '',
      languages: DataType.LanguageConst,
      languageEnum: DataType.Languages,
      languageselected: {
        show: false,
        selectedLanguage: this.selectedLanguage,
        style: 'position: absolute; left: 105px; top: -5px; width: 152px;',
        textStyle: 'position: absolute; left: 17px; top: 17px;'
      },
      languageText: {
        style: 'position: absolute; left: 95px; top: 17px;',
        selectedLanguage: this.selectedLanguage
      },
      filteredLanguage: '',
      authorization: {},
      roleList: [],
      cloNumbers: 5,
      flag: true,
      tab: null,
      sliderColor: '',
      thColor: '',
      tabColor: '',
      clickItemIndex: 0,
      clickItemIndexTable: 0,
      dataWorkQueueTable: [],
      dataWorkQueue: [
        {
          code: DataType.PrivilegeCode.RESOLVED_QUEUE,
          color: ['rgb(255, 0, 38)', '#F2F5FD'],
          count: 0,
          indexOfPage: 1,
          isEnd: true,
          isLoading: true,
          items: [],
          key: 'Resolved',
          status: 40006,
          title: 'Resolved'
        },
        {
          code: DataType.PrivilegeCode.UNRESOLVED_QUEUE,
          color: ['rgb(255, 0, 38)', '#F2F5FD'],
          count: 0,
          indexOfPage: 1,
          isEnd: true,
          isLoading: true,
          items: [],
          key: 'UnResolved',
          status: 40007,
          title: 'UnResolved'
        }
      ],
      runtimeHeader: LIST_TABLE_HEADER.WORK_QUEUE_TABLE_HEADERS,
      portfolioId: null
    }
  },
  watch: {
    thColor (val) {
      this.$refs.UI.style.setProperty('--thColor', val)
    },
    tabColor (val) {
      this.$refs.UI.style.setProperty('--tabColor', val)
    },
    'store.getters.getRoleCode': function () {
      if (this.loanPhase === DataType.LoanPhaseEnum.LOAN_COLLECTION.value) {
        this.getComplaintQueue(this.clickItemIndex)
      }
    },
    '$store.getters.getRuntimePortfolio': {
      handler: function (newVal, oldVal) {
        if ($tool.compareTwoPortfolioArray(newVal, oldVal)) {
          this.initData()
        }
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('loadAccountData')
    this.account = this.store.getters.getAccount
    if (this.account.languagePreference === this.languages[0].value) {
      this.languageselected.show = true
      this.selectedLanguage = this.languages[0].text
    } else {
      this.languageselected.show = false
      const languageOption = this.languages.find(lang => lang.value === this.account.languagePreference)
      this.selectedLanguage = languageOption ? languageOption.text : 'unknown language'
    }
    this.filteredLanguage = this.selectedLanguage.trim().replace(/\s*Only\s*/i, '')
    this.languageEnum.forEach(language => {
      if (this.filteredLanguage === 'All') {
        this.filter.isAllLanguage = true
      } else if (this.filteredLanguage === language.text) {
        this.filter[`is${language.text}`] = true
      }
    })
    this.initData()
  },
  methods: {
    filterChange () {
      if ($tool.isNotEmpty(this.filter)) {
        this.filter = {}
      }
      this.filteredLanguage = this.selectedLanguage.trim().replace(/\s*only\s*/i, '')
      this.languageEnum.forEach(language => {
        if (this.filteredLanguage === 'All') {
          this.filter.isAllLanguage = true
        } else if (this.filteredLanguage === language.text) {
          this.filter[`is${language.text}`] = true
        }
      })
      if (this.dataWorkQueue.length !== 0) {
        this.dataWorkQueue.map((workQueue, index) => {
          this.initData()
        })
      }
    },
    initData () {
      this.layoutData.setting.workQueue = this.dataWorkQueue
      this.sliderColor = this.dataWorkQueue[this.clickItemIndex].color[0]
      this.thColor = this.dataWorkQueue[this.clickItemIndex].color[0]
      this.tabColor = this.dataWorkQueue[this.clickItemIndex].color[1]
      this.portfolioId = ''
      this.$store.getters.getRuntimePortfolio.map(item => {
        if ($tool.isEmpty(this.portfolioId)) {
          this.portfolioId = `${item}`
        } else {
          this.portfolioId = `${this.portfolioId},${item}`
        }
      })
      this.dataWorkQueue.forEach(item => {
        item.isLoading = true
      })
      this.getComplaintQueue(0, 'Resolved')
      this.initTableCount()
    },
    setUI () {
      this.$refs.UI.style.setProperty('--thColor', this.thColor)
      this.$refs.UI.style.setProperty('--tabColor', this.tabColor)
    },
    clickItem (index) {
      this.sliderColor = this.dataWorkQueue[index].color[0]
      this.thColor = this.dataWorkQueue[index].color[0]
      this.tabColor = this.dataWorkQueue[index].color[1]
      let workQueue
      if (this.flag) {
        this.clickItemIndex = index
        workQueue = this.dataWorkQueue[this.clickItemIndex]
      } else {
        this.clickItemIndexTable = index
        workQueue = this.dataWorkQueue[this.clickItemIndexTable]
        this.pagination.index = 1
        this.options.page = 1
        this.options.pageCount = 0
        workQueue.indexOfPage = 1
        this.dataWorkQueue[this.clickItemIndexTable].items = []
      }
      this.getComplaintQueue(index, workQueue.key)
    },
    initTableCount () {
      if (this.dataWorkQueue.length !== 0) {
        this.dataWorkQueue.map((workQueue, index) => {
          this.getComplaintQueueCount(index, workQueue.key)
        })
      }
    },
    getComplaintQueue (index, key) {
      const $this = this
      let number = index
      if (number === 0) {
        number = number + 3
      }
      const input = {
        complaintStatus: number,
        portfolioIds: this.portfolioId,
        page: 1,
        pageSize: 20,
        sortBy: '',
        filter: this.filter
      }
      ComplaintApi.getComplaintQueue(input, function (result) {
        if (number === 1 || number === 2) {
          $this.dataWorkQueue[1].items = result
        } else {
          $this.dataWorkQueue[0].items = result
        }
      })
      this.getComplaintQueueCount(index, key)
    },
    async getComplaintQueueCount (index, key) {
      const $this = this
      if (index === 0) {
        index = 3
      }
      const input = {
        complaintStatus: index,
        portfolioIds: this.portfolioId,
        sortBy: '',
        phase: 70000,
        beginDate: '',
        endDate: '',
        filter: this.filter
      }
      await ComplaintApi.getComplaintQueueCount(input, function (data) {
        $this.getQueueCountCallBack(data, key)
        if (index === 3) {
          index = 0
        }
        $this.dataWorkQueue[index].isLoading = false
      }, function (err) {
        console.error(err)
      })
    },
    getQueueCountCallBack (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.count = data
        }
      })
    },
    scrollEvent (e) {
      if (Math.ceil(e.srcElement.scrollTop) + e.srcElement.clientHeight === e.srcElement.scrollHeight) {
        this.scrollHandler(this.dataWorkQueue[this.clickItemIndex], this.clickItemIndex)
      }
    },
    mouseOver ($event) {
      $event.currentTarget.className = 'active'
    },
    mouseLeave ($event) {
      $event.currentTarget.className = 'scroll'
    }
  }
}
</script>

<style lang="scss" scoped>
.queue-header-btn {
  top:inherit;
  height: 45px;
.topLeft {
  position:fixed;
  text-transform: capitalize;
}
}
.loan-work-queue {
  max-width: calc(100vw) !important;
  min-width: calc(100vw - 280px) !important;
  height: calc(100vh - 165px);
  padding-right: 0;
}
.queue-content {
  height: calc(100vh - 278px);
}
.scroll {
  height: calc(100vh - 285px);
  overflow: auto;
  width: 100%;
}
.scroll::-webkit-scrollbar {
  width: 6px;
}
.active {
  height: calc(100vh - 285px);
  overflow: auto;
  width: 100%;
}
.active::-webkit-scrollbar {
  width: 6px;
}
.active::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #C1C1C1;
}
.active::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #F1F1F1;
  border-radius: 5px;
}
.dateRange {
  position: absolute;
  left: 142px;
  top: 15px;
}
.choose {
  color: #000 !important;
}
.v-icon {
  color: #ccc;
  font-size: 18px;
  margin-top: -2px;
}
.topRight {
  position: fixed;
  top: inherit;
  right: 0;
  color: #000;
  font-size: 28px;
  cursor: pointer;
}
.nav-tabs{
  list-style:none;
  padding: 0;
  width:auto;
  overflow: hidden;
  background: white;
  text-align: center;
  margin: -4px 0 0;
}
.nav-item {
  float: left;
  background: #fafafa;
  width: auto;
  height: 28px;
}
.nav-item a {
  height: 28px;
  font-size: 18px;
  vertical-align: 10px;
  text-decoration: none;
  padding: 5px 20px;
  color: #000;
}
.nav-item a:hover, .nav-item a.active
{
  background-color: #03a9f4;
  color: #000;
}
.elevation-1 td {
  font-size: 10px !important;
  white-space: nowrap;
}
.elevation-1 th {
  font-size: 6px !important;
}
.queue-content-table {
  height: calc(100vh - 288px);
}
.elevation-1 {
  height: calc(100vh - 298px);
}
.vue-waterfall {
  overflow: hidden;
}
.tableShow {
  width:4px;
  height: 38px;
  display: inline-block;
  border-radius: 20px;
}
.tableLoanDetails {
  display: inline-block;
  margin-left: 12px;
}
.tableLoanNo {
  color:#161A40;
  font-weight: bolder;
  font-size: 16px;
  height: 20px;
}
.tableName {
  color:#3F4360;
  font-size: 14px;
  height: 18px;
}
.tableRequestedAmount {
  color:#3F4360;
  font-weight: 500;
  font-size: 14px;
  margin-left: 8px;
  height: 18px;
}
.detailBtn {
  text-transform: none;
  color: #FFF;
  font-size: 12px;
  height: 16px;
  border-radius: 2px;
}
.locked-icon {
  margin-left: 8px;
  margin-bottom: -4px;
}
.loanFirst {
  width: 318px;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border: none;
}
.v-tab {
  text-transform: capitalize;
}
</style>

<style>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: var(--thColor);
  white-space: nowrap;
}
.queue-tab-card .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr {
  height: 66px;
}
.queue-tab .theme--dark.v-icon, .queue-tab-card .theme--dark.v-icon{
  color: var(--thColor);
}
.theme--light.v-data-table > .v-data-table__wrapper {
  /*
  overflow-x: hidden;
  */
}
.loan-work-queue .elevation-1 .v-data-table__wrapper {
  height: calc(100vh - 358px) !important;
}

.loan-queue-tabs .v-tab--active {
  color: var(--thColor) !important;
}
.loan-queue-tabs .v-tab--active:hover {
  background: var(--tabColor) !important;
  color: var(--thColor) !important;
}
.loan-queue-tabs .v-tab:hover {
  background: var(--tabColor) !important;
}
.loan-queue-tabs.theme--dark.v-tabs .v-tab--active:hover::before, .theme--dark.v-tabs .v-tab--active::before {
  opacity: 0;
}
.loan-queue-tabs.theme--dark.v-tabs .v-tab:hover::before {
  opacity: 0;
}
</style>
